import { thank_you_page_stages } from "features/ThankYouPages/constants/ThankYouPages.constants";

export const thank_you_page_home_tab_ids = {
  live: `${thank_you_page_stages.published}`,
  drafts: [
    thank_you_page_stages.template_selecting,
    thank_you_page_stages.details_editing,
  ].join(","),
};

export const thank_you_page_home_tabs = {
  [thank_you_page_home_tab_ids.live]: {
    label: "Published",
    id: thank_you_page_home_tab_ids.live,
    emptyTitle: "Create a Thank You Page",
    emptySubtitle:
      "As soon as you publish a thank you page, it will show up here.",
    priority: 0,
  },
  [thank_you_page_home_tab_ids.drafts]: {
    label: "Drafts",
    id: thank_you_page_home_tab_ids.drafts,
    emptyTitle: "No drafts yet",
    emptySubtitle: "All your drafts will be displayed here.",
    priority: 1,
  },
};

export const default_thank_you_page_home_stage_id =
  thank_you_page_home_tab_ids.live;

export const thank_you_page_home_tabs_list = Object.values(
  thank_you_page_home_tabs
).sort((a, b) => a.priority - b.priority);

export const filterConfig = [
  {
    source: "title",
    placeholder: "Name",
    type: "input",
  },
  {
    source: "listing_title",
    placeholder: "Offering Name",
    type: "input",
  },
];

export const filterChipFormatter = (filter, value) => {
  switch (filter) {
    case "title__icontains":
      return `Name: ${value}`;
    case "listing_title__icontains":
      return `Offering Name: ${value}`;
    default:
      return null;
  }
};
